export default "__VITE_ASSET__5jbO30w9__"